<template>
  <div id="RainbowShoot"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue";
import colorTool from "@/utils/colorTool";
const {changeToRgb, rgbToHsb} = colorTool()


const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let animateSpeed = ref(10) // 10,25,50
let high = ref(null)
let low = ref(null)
let nowTemperature = ref(null)
let backgroundColor = ref('rgb(0,0,0)')
let drawPot = ref(0)



const handleGetAnimateSpeed = (high, low, now = 10) => {

  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 9) // 將高低差 分為 10個單位, 1單位

  let range = Math.trunc((now - low) / lowHeightRange)

  // 設定速度
  if (range <= 3) animateSpeed.value = 10
  else if (range >= 7 ) animateSpeed.value = 50
  else animateSpeed.value = 25
}


const rainbowShootAnimate = (sketch) => {
	let cw = defaultWidth.value
	let ch = defaultHeight.value
  let stars = [];
	sketch.setup = () => {
    sketch.createCanvas(cw, ch)//
    stars = []
    for(let i =0 ; i < 500; i++){
      stars.push(new Star());
    }
	}

	sketch.draw = () => {
    // speed 10 25 50
    drawPot.value ++
    sketch.background (backgroundColor.value);
    sketch.translate (sketch.width/ 2, sketch.height /2);
    for (let star of stars) {
      star.update(animateSpeed.value);
      star.show_low();
      if (animateSpeed.value > 10) star.show_default();
      if (animateSpeed.value > 25) star.show_high();
    }
	}

  class Star{
    constructor () {
      this.x = sketch.random(-sketch.width, sketch.width);
      this.y = sketch.random(-sketch.height, sketch.height);
      this.z = sketch.random(sketch.width);
      this.pz = this.z;
    }


    update(speed) {
      this.z =this.z -speed;
      if(this.z <1) {
        this.z = sketch.width;
        this.x = sketch.random(-sketch.width, sketch.width);
        this.y = sketch.random(-sketch.height, sketch.height);
        this.pz = this.z;
      }
    };

    show_low(){
      sketch.fill(255,255,255);
      sketch.noStroke();

      let sx = sketch.map(this.x / this.z, 0,1,0, sketch.width);
      let sy = sketch.map(this.y / this.z, 0,1,0, sketch.height);

      let r = sketch.map(this.z, 0, sketch.width, 10,0);
      sketch.ellipse(sx, sy, r/2, r/2);

      let px = sketch.map((this.x / this.pz)*1, 0,1,0, sketch.width);
      let py = sketch.map((this.y / this.pz)*1, 0,1,0, sketch.height);

      this.pz =this.z;

      sketch.push()
      sketch.strokeWeight(r/2);
      sketch.stroke(255,255,255, 120);
      sketch.line(px,py,sx,sy);

      // sketch.strokeWeight(r/2);
      // sketch.stroke(255,0,255, 120);
      // sketch.line(px*.8,py*.8,sx *1,sy *1);

      sketch.strokeWeight(r/2.4);
      sketch.stroke(0,0,255, 120);
      sketch.line(px*.7,py*.7,sx*.9,sy*.9);

      // sketch.strokeWeight(r/2.8);
      // sketch.stroke(0,255,255, 120);
      // sketch.line(px*.6,py*.6,sx*.8,sy*.8);

      sketch.strokeWeight(r/3.2);
      sketch.stroke(0,255,0, 120);
      sketch.line(px*.5,py*.5,sx*.7,sy*.7);

      // sketch.strokeWeight(r/3.6);
      // sketch.stroke(255,255,0, 120);
      // sketch.line(px*.4,py*.4,sx*.6,sy*.6);

      sketch.strokeWeight(r/4);
      sketch.stroke(255,0,0, 120);
      sketch.line(px*.3,py*.3,sx*.5,sy*.5);
      sketch.pop()
    };
    show_default(){
      sketch.fill(255,255,255);
      sketch.noStroke();

      let sx = sketch.map(this.x / this.z, 0,1,0, sketch.width);
      let sy = sketch.map(this.y / this.z, 0,1,0, sketch.height);

      let r = sketch.map(this.z, 0, sketch.width, 10,0);
      sketch.ellipse(sx, sy, r/2, r/2);

      let px = sketch.map((this.x / this.pz)*1, 0,1,0, sketch.width);
      let py = sketch.map((this.y / this.pz)*1, 0,1,0, sketch.height);

      this.pz =this.z;

      sketch.push()

      sketch.strokeWeight(r/2);
      sketch.stroke(255,0,255, 120);
      sketch.line(px*.8,py*.8,sx *1,sy *1);

      sketch.strokeWeight(r/2.8);
      sketch.stroke(0,255,255, 120);
      sketch.line(px*.6,py*.6,sx*.8,sy*.8);

      sketch.strokeWeight(r/3.2);
      sketch.stroke(0,255,0, 120);
      sketch.line(px*.5,py*.5,sx*.7,sy*.7);

      sketch.strokeWeight(r/4);
      sketch.stroke(255,0,0, 120);
      sketch.line(px*.3,py*.3,sx*.5,sy*.5);
      sketch.pop()
    };

    show_high(){
      sketch.fill(255,255,255);
      sketch.noStroke();

      let sx = sketch.map(this.x / this.z, 0,1,0, sketch.width);
      let sy = sketch.map(this.y / this.z, 0,1,0, sketch.height);

      let r = sketch.map(this.z, 0, sketch.width, 10,0);
      sketch.ellipse(sx, sy, r/2, r/2);

      let px = sketch.map((this.x / this.pz)*1, 0,1,0, sketch.width);
      let py = sketch.map((this.y / this.pz)*1, 0,1,0, sketch.height);

      this.pz =this.z;

      sketch.push()

      sketch.strokeWeight(r/2);
      sketch.stroke(255,255,255, 120);
      sketch.line(px,py,sx,sy);

      sketch.strokeWeight(r/2);
      sketch.stroke(255,0,255, 120);
      sketch.line(px*.8,py*.8,sx *1,sy *1);

      sketch.strokeWeight(r/3.2);
      sketch.stroke(0,255,0, 120);
      sketch.line(px*.5,py*.5,sx*.7,sy*.7);

      sketch.strokeWeight(r/3.6);
      sketch.stroke(255,255,0, 120);
      sketch.line(px*.4,py*.4,sx*.6,sy*.6);

      sketch.strokeWeight(r/4.4);
      sketch.stroke(255,0,0, 120);
      sketch.line(px*.2,py*.2,sx*.4,sy*.4);
      sketch.pop()
    };
  }

}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 7200) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(rainbowShootAnimate, 'RainbowShoot')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(rainbowShootAnimate, 'RainbowShoot')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
  } = effectThemeData


  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  if (IsDynamicMode.toString() === 'false') {
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    handleGetAnimateSpeed(high.value, low.value, nowTemperature.value)
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(rainbowShootAnimate, 'RainbowShoot')
})


onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  backgroundColor.value = 'rgb(0,0,0)'
  high.value = null
  low.value = null
  animateSpeed.value = 10
  high.value = null
  low.value = null
  initAnimate()
})

</script>
